import { SvgIcon } from '@mui/material';
import React from 'react';

const SCOPaymentIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 150 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m33.45,3.75v31.61H2.52C13.05,24.59,23.41,14.01,33.45,3.75Z" />
          <path d="m54.52,62.07h54.89V7.05c0-3.9-3.01-7.05-6.73-7.05h-60.79v38.8c0,3-2.32,5.44-5.18,5.44H0v98.74c0,3.87,3,7.02,6.68,7.02h93.83c4.82,0,8.74-4.06,8.89-9.16h-54.88c-6.8,0-12.31-5.54-12.31-12.36v-54.04c0-6.83,5.51-12.36,12.31-12.36Zm-3.91-32.72c.8-1.9,2.29-2.71,4.26-2.7,5.54.01,11.07,0,16.6,0s10.98-.03,16.48.01c3.26.03,5.36,3.14,4.12,6.09-.81,1.9-2.3,2.7-4.27,2.7-5.81-.03-11.63-.01-17.44-.01-5.27,0-10.52.04-15.78-.01-3.16-.02-5.2-3.19-3.97-6.07Zm0,17.57c.8-1.91,2.29-2.7,4.26-2.7,5.95.02,11.91.01,17.86.01,5.13,0,10.24-.04,15.36.01,3.16.04,5.2,3.18,3.97,6.09-.8,1.89-2.29,2.7-4.26,2.69-5.54-.01-11.07,0-16.6,0s-10.98.03-16.48-.01c-3.26-.03-5.36-3.14-4.11-6.09Z" />
        </g>
        <path d="m141.14,68.75H58.49c-4.88,0-8.86,3.99-8.86,8.89v47.63c0,4.9,3.97,8.89,8.86,8.89h82.65c4.88,0,8.86-3.99,8.86-8.89v-47.63c0-4.9-3.97-8.89-8.86-8.89Zm-82.65,5.45h82.65c1.89,0,3.43,1.55,3.43,3.45v4.95H55.06v-4.95c0-1.9,1.54-3.45,3.43-3.45Zm82.65,54.52H58.49c-1.89,0-3.43-1.55-3.43-3.45v-27.38h89.52v27.38c0,1.9-1.54,3.45-3.43,3.45Z" />
      </svg>
    </SvgIcon>
  );
};

export default SCOPaymentIcon;
